    /**
     * Created by anthony on 2/7/14.
     */
    var bin = angular.module('bin');
    bin.classy.controller({
        name: 'BinsController',
        inject: ['$scope', '$sce', '$rootScope', '$http', 'BinFactory', '$location', '$anchorScroll', 'BinSummaryService', 'BinService'],
        init: function()
        {
            this.$.BinFactory = this.BinFactory;
            this.$.BinService = this.BinService;
            var parent = this; 
            this.$.BinFactory = this.BinFactory;
            this.$.$on("reloadBins", function (event) {
                parent.BinFactory.getBinCount();
            });
            this.$.$sce = this.$sce;

            this.BinSummaryService.refresh();
        },
        binClick:function(bin)
        {
            if (this.BinFactory.bins[bin])
            {
                if (this.BinService.getBin() == bin)
                {
                    var filters = ["taxFilter", "gradeFilter", "NRFilter", "SubCatsFilter", "accountsFilter"]
                    for (var i = 0; i < filters.length; i++)
                    {
                        var filter = filters[i];
                        for (let prop in this.BinService.filter[filter].values)
                            this.BinService.filter[filter].values[prop] = false;
                    }
                    this.BinService.updateFilter(filter);
                    this.BinService.setFilter(filter, this.BinService.filter[filter]);
                }
                else
                {
                    this.$location.hash('app0');
                    this.$anchorScroll();
                    this.BinService.setBin(bin);
                    this.BinSummaryService.refresh();
                }
            }
            else {
                this.BinService.setBin(bin);
                this.BinSummaryService.refresh();
            }

        }
    });
